module.exports = __webpack_public_path__ + "img/zjbb5.ee3fa729.jpg";